import React from 'react';
import { Award, Users, Handshake } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { aboutContent } from '../mock/mockData';

const About = () => {
  const iconMap = {
    Excellence: Award,
    Expertise: Users,
    Partenariat: Handshake
  };

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            {aboutContent.title}
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto"></div>
        </div>

        {/* Description */}
        <div className="max-w-4xl mx-auto mb-16">
          <p className="text-lg text-slate-700 leading-relaxed mb-6">
            {aboutContent.description}
          </p>
          <p className="text-lg text-slate-700 leading-relaxed">
            {aboutContent.mission}
          </p>
        </div>

        {/* Values */}
        <div className="grid md:grid-cols-3 gap-8">
          {aboutContent.values.map((value, index) => {
            const IconComponent = iconMap[value.title];
            return (
              <Card
                key={index}
                className="border-slate-200 hover:shadow-lg transition-shadow duration-300"
              >
                <CardContent className="p-8 text-center">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-4">
                    <IconComponent className="text-blue-600" size={32} />
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-3">
                    {value.title}
                  </h3>
                  <p className="text-slate-600">
                    {value.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;
